import Autocomplete from 'components/base/Autocomplete';

const OrgSelector = ({ orgs, selectedOrg, onChange }) => {
  const orgsOptions = orgs.map(org => ({
    value: org.value,
    displayValue: org.displayValue,
    searchableValue: org.displayValue
  }));

  return (
    <Autocomplete
      height='3rem'
      options={orgsOptions}
      selectedOptionValue={selectedOrg}
      onChange={onChange}
      dataCy='org-selector'
    />
  );
};

export default OrgSelector;
